import Button from "../Button"

export default function About5({ data }) {
    const {
        image_url,
        section_title,
        section_subtitle,
        section_description,
        phone_number,
        experience_title,
        experience_year,
        feature_list,
        action_text,
        action_url
    } = data
    return (
        <div className="container">
            <div className="row align-items-center cs_gap_y_40">
                <div className="col-lg-5">
                    <div className="position-relative">
                        {image_url && <img src={image_url ?? ""} alt={section_title ?? ""} />}
                        {(experience_year ?? experience_title) && (
                            <div className="cs_experience_box cs_style_1 cs_accent_bg position-absolute">
                                <h3
                                    className="cs_white_color cs_fs_60 cs_bold mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: experience_year ?? ""
                                    }}
                                />
                                <h4
                                    className="cs_white_color mb-0 cs_fs_30 cs_normal"
                                    dangerouslySetInnerHTML={{
                                        __html: experience_title ?? ""
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-lg-6 offset-lg-1">
                    <div className="cs_section_heading cs_style_1">
                        {section_subtitle && (
                            <p
                                className="cs_section_subtitle cs_fs_18 cs_medium"
                                dangerouslySetInnerHTML={{
                                    __html: section_subtitle
                                }}
                            />
                        )}
                        {section_title && (
                            <>
                                <h2
                                    className="cs_section_title cs_fs_53 cs_normal mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: section_title
                                    }}
                                />
                                <div className="cs_height_26 cs_height_lg_20" />
                            </>
                        )}
                        {section_description && (
                            <>
                                <p
                                    className="mb-0"
                                    dangerouslySetInnerHTML={{
                                        __html: section_description
                                    }}
                                />
                                <div className="cs_height_30 cs_height_lg_30" />
                            </>
                        )}
                    </div>
                    <ul className="cs_list cs_style_1 cs_type_1 cs_mp0">
                        {feature_list?.map((item, index) => (
                            <li key={index}>
                                {(item?.feature_title ?? item?.feature_subtitle) && (
                                    <i className="cs_tick_icon cs_accent_color d-flex">
                                        <i className="fa-light fa-circle-check" style={{ fontSize: '30px' }}></i>
                                    </i>
                                )}

                                {item?.feature_title && (
                                    <h3
                                        className="cs_fs_24 cs_normal mb-0"
                                        dangerouslySetInnerHTML={{
                                            __html: item.feature_title
                                        }}
                                    />
                                )}
                                {item?.feature_subtitle && (
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: item.feature_subtitle
                                        }}
                                    />
                                )}
                            </li>
                        ))}
                    </ul>
                    <div className="cs_height_50 cs_height_lg_30" />
                    <div className="cs_btn_group cs_style_1">
                        {(action_url ?? action_text) && (
                            <Button href={action_url ?? "#"} btnText={action_text ?? ""} btnClass="cs_btn cs_style_1 cs_type_2 cs_white_color cs_primary_bg" />
                        )}
                        {phone_number && (
                            <div className="cs_hero_phone_number cs_primary_font cs_fs_24 cs_primary_color">
                                <span className="cs_accent_bg cs_white_color cs_center">
                                    <i className="cs_center">
                                        <i className="fa-light fa-phone" style={{ fontSize: '16px' }}></i>
                                    </i>
                                </span>
								<div style={{ direction: "ltr" }}>
								  {phone_number}
								</div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}